import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import type { DropdownLocation } from "@redotech/redo-web/locations/location-dropdown";

export function getSelectedLocationId(
  groups: readonly FulfillmentGroupData[],
): string | null {
  const mixed = areLocationsMixed(groups);
  if (mixed) {
    return null;
  }
  const uniqueSelectedLocationIds = new Set(
    groups.map((group) => group.selectedLocationId),
  );
  return [...uniqueSelectedLocationIds][0] ?? null;
}

export function areLocationsMixed(
  groups: readonly FulfillmentGroupData[],
): boolean {
  const uniqueSelectedLocationIds = new Set(
    groups.map((group) => group.selectedLocationId),
  );
  return uniqueSelectedLocationIds.size > 1;
}

export function getLocationsForMove(
  groups: readonly FulfillmentGroupData[],
): readonly DropdownLocation[] {
  return groups.reduce((acc, group) => {
    const groupLocations = (group.locationsForMove ?? []).filter((location) => {
      const isSelected = location.id === group.selectedLocationId;
      const isMovable =
        location.movable && location.unavailableLineItemsCount === 0;
      const isSelectedByFO = location.selectedByFO; // can be true even if the group has a manual location selected
      return isSelected || isMovable || isSelectedByFO;
    });
    if (acc.length === 0) {
      return groupLocations;
    }
    const locations = acc.filter((location) =>
      groupLocations.some((l) => l.id === location.id),
    );
    return locations;
  }, [] as DropdownLocation[]);
}
